import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import { DocumentsSections } from '@/components/documents/DocumentsSections';
import { Tooltip } from '@/components/Tooltip';
import { Button } from '@/components/ui/button';
import { GenerateLOAWizard } from '@/sections/export/GenerateLOAWizard';
import { useAuth } from '@/state/auth';

export const LOATab: React.FC = () => {
  const { isPraetorianUser } = useAuth();
  const [wizardOpen, setWizardOpen] = useState(false);

  return (
    <div className="flex h-full flex-col gap-4 overflow-hidden">
      <DocumentsSections
        query="loa"
        includeLOA
        enableUpload={false}
        enableSearch={true}
        enableFavorites={true}
        isPraetorianUser={isPraetorianUser}
        showInternalSection={false}
        heading="Letters of Attestation"
        headerAction={
          isPraetorianUser ? (
            <Button size="sm" onClick={() => setWizardOpen(true)}>
              <DocumentTextIcon className="size-4" />
              Generate LOA
            </Button>
          ) : (
            <Tooltip title="Managed by Praetorian">
              {/* span wrapper enables hover/focus events on disabled button for tooltip */}
              <span tabIndex={0}>
                <Button size="sm" disabled>
                  <DocumentTextIcon className="size-4" />
                  Generate LOA
                </Button>
              </span>
            </Tooltip>
          )
        }
        emptyState={{
          title: 'No Letters of Attestation Yet',
          description: isPraetorianUser
            ? 'Generate your first LOA to get started'
            : 'Letters of attestation generated for you will appear here',
          actionLabel: 'Generate LOA',
          onAction: isPraetorianUser ? () => setWizardOpen(true) : undefined,
        }}
      />

      <GenerateLOAWizard open={wizardOpen} onOpenChange={setWizardOpen} />
    </div>
  );
};
